import { CommunityController as Community } from "./controller";

export default Community;
